import React from 'react'

export const DataContext = React.createContext()

export const DataProvider = function(props) {

  const [ state, updateState ] = React.useState({ 
    crime: props.defaultCrime, 
    district: props.defaultDistrict, 
    district_label: "", 
    district_type: "", 
    district_extra: "", 
    crimeData: props.crimeData,
    colorSteps: [],
    maxv: 0
  });

  return (
    <DataContext.Provider value={[ state, updateState ]}>
      {props.children}
    </DataContext.Provider>
  );

}
